import BASE_URL from "../config";

// Submits the public "Contact Us" form. No auth required.
export const submitContactForm = async (payload) => {
  const response = await fetch(`${BASE_URL}/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};
